<template>
  <div class="animated fadeIn">
    <b-modal
      ref="modal-oportunities"
      scrollable
      centered
      button-size="sm"
      v-on:hide="hideModal"
      size="xl"
    >
      <template #modal-title>
        <i class="fas fa-address-card"></i> Oportunidades
      </template>
      <span style="display: flex; align-items: center">
        <p
          v-show="toggleValue"
          class="toggle__text"
          @click="toggleAll"
        >
          Vincular Contatos
        </p>
        <ToogleSwitch
          v-model="toggleValue"
          @toggle-all="$emit('toggle-all')"
          style="transform: scale(1.1); margin: 0 10px"
        />
        <span style="display: flex; align-items: center">
          <p
            v-show="!toggleValue"
            class="toggle__text"
            @click="toggleAll"
          >
            Criar card
          </p>
        </span>
      </span>

      <div
        class="p-3"
        v-show="!toggleValue"
      >
        <Tables
          ref="tableOportunities"
          :showTipFooter="false"
          :columns="[
            'Protocolo',
            'Quadro',
            'Coluna',
            'Responsável',
            'Data Abertura',
            'Abrir Evento'
          ]"
        >
          <tr
            v-for="obj in this.objList"
            v-bind:key="obj.id"
          >
            <TableColumn
              :IsText="true"
              v-on:Edit="openCardModal(obj.id)"
              :status="1"
              :value="obj.protocolo ? obj.protocolo : '-'"
            />
            <TableColumn
              :IsText="true"
              v-on:Edit="openCardModal(obj.id)"
              :status="1"
              :value="
                obj.boardColumn.board.nome ? obj.boardColumn.board.nome : '-'
              "
            />
            <TableColumn
              :IsText="true"
              v-on:Edit="openCardModal(obj.id)"
              :status="1"
              :value="obj.boardColumn.nome ? obj.boardColumn.nome : '-'"
            />
            <TableColumn
              :IsText="true"
              v-on:Edit="openCardModal(obj.id)"
              :status="1"
              :value="
                obj.responsaveis.length > 0 && obj.responsaveis[0].usuario
                  ? obj.responsaveis[0].usuario.nomePessoa
                  : '-'
              "
            />
            <TableColumn
              :IsText="true"
              v-on:Edit="openCardModal(obj.id)"
              :status="1"
              :value="obj.dataCriacao ? formatDate(obj.dataCriacao, true) : '-'"
            />
            <td class="row justify-content-around">
              <div
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <i
                  class="fa fa-plus-circle cursor-pointer mt-1"
                  style="color: black; font-size: 1.1rem"
                  :title="'Oportunidades'"
                  @click="openNewFollowUp(obj)"
                ></i>
              </div>
            </td>
          </tr>
        </Tables>
      </div>
      <div
        class="p-3"
        v-show="toggleValue"
      >
        <div
          class="input-group"
          style="background: none"
        >
          <div class="col-md-6 mt-2">
            <SelectBoard
              :onlyActive="true"
              :selectedOption="boardId"
              @onSelect="(selectedValue) => loadColumns(selectedValue)"
            />
          </div>
          <div class="col-md-6 mt-2">
            <SelectBoardColumn
              v-if="boardId"
              :boardId="boardId"
              :key="boardId"
              :selectedOption="boardColumnId"
              @onSelect="saveBoardAndColumn"
            />
          </div>
          <div class="col-md-6 pt-2">
            <SelectOrigem
              v-if="boardColumnId"
              :selectedOption="origemId"
              @onSelect="saveOrigin"
            />
          </div>
        </div>
      </div>
      <template
        #modal-footer
        v-if="toggleValue"
      >
        <div class="text-right">
          <DefaultButton
            btnVariant="btn-third justify-content-center"
            :onClick="onSave"
            icon="fas fa-check-circle"
            text="Salvar"
          />
        </div>
      </template>
      <template
        #modal-footer
        v-else
      >
        <div class="text-right"></div>
      </template>
    </b-modal>
    <ModalCard
      ref="ModalCard"
      v-if="selectedCardOpen"
      :boardColumns="[]"
      @hideModal="closeCardModal"
      :key="selectedCardOpen"
      :cardId="selectedCardOpen"
    />
    <ModalNewFollowUp
      v-if="openFollowUpModal"
      ref="ModalNewFollowUp"
      :card="task"
      v-on:Reload="closeNewFollowUp"
    />
  </div>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
import BoardRepositoryV2 from '../../../../shared/http/repositories/crm/board_v2.js'
import CardRepository from '../../../../shared/http/repositories/crm/card'

import DefaultButton from '@/components/UI/button/defaultButton.vue'
import ToogleSwitch from '@/components/UI/toogleSwitch/toogleSwitch.vue'
import SelectBoard from '@/components/forms/selects/SelectBoard.vue'
import SelectBoardColumn from '@/components/forms/selects/SelectBoardColumn.vue'
import SelectEvento from '@/components/forms/selects/SelectEvento.vue'
import SelectOrigem from '@/components/forms/selects/SelectOrigem.vue'
import ActionsForm from '@/shared/mixins/actionsForm'
import ModalNewFollowUp from '@/views/private/crm/details/followup/followup.vue'

export default {
  name: 'OportunityModal',
  mixins: [ActionsForm],
  props: {},
  data () {
    return {
      selectedCardOpen: null,
      person: null,
      toggleValue: false,
      eventoId: null,
      boardId: null,
      boardColumnId: null,
      origemId: null,
      motivoId: null,
      openFollowUpModal: false,
      task: null
    }
  },
  components: {
    DefaultButton,
    ModalNewFollowUp,
    SelectOrigem,
    SelectBoard,
    SelectEvento,
    SelectBoardColumn,
    ToogleSwitch,
    ModalCard
  },
  computed: {},
  created () {},
  mounted () {},
  methods: {
    showModal (obj) {
      this.person = obj
      this.$refs['modal-oportunities'].show()
      this.$nextTick(() => {
        this.onLoadTabOportunidades(this.person.document)
      })
    },
    hideModal () {
      this.$emit('HideModal')
    },
    async onSave () {
      await BoardRepositoryV2.Card_Create(
        this.boardId,
        this.boardColumnId,
        this.createData()
      )
        .then((response) => {
          this.hideModal()
          toast.success(this.$lang.Common.Alerts.Success, 'Nova Oportunidade')
          this.toggleValue = false
          this.$nextTick(() => {
            this.onLoadTabOportunidades(this.person.document)
          })
        })
        .catch((err) => {
          console.error(err, 'if')
          this.onException(err)
        })
    },
    createData () {
      let cardData = {
        boardColumnId: this.boardColumnId,
        motivoPerdaId: null,
        posicao: 0,
        situacao: 'ATIVO',
        countReativado: 0,
        dataCriacao: new Date().toISOString(),
        dataInicioSituacao: new Date().toISOString(),
        dataReativacao: null,
        origemLeadId: this.origemId,
        pessoaId: this.person.id
      }
      return cardData
    },
    onEdit () {},
    onClear () {
      this.$root.$emit('clearForm')
    },
    openCardModal (cardId) {
      this.selectedCardOpen = cardId
    },
    closeCardModal () {
      this.selectedCardOpen = null
    },
    async onLoadTabOportunidades (document) {
      const response = await CardRepository.SearchAllByDocument(
        document,
        '',
        50,
        0
      )
      this.onResultGrid(response, this.$refs.tableOportunities)
    },
    formatDate (d, hasTime) {
      const date = new Date(d)
      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      const seconds = date.getSeconds().toString().padStart(2, '0')

      return (
        `${day}/${month}/${year}` +
        (hasTime ? ` às ${hours}:${minutes}:${seconds}` : '')
      )
    },
    toggleAll () {
      this.toggleValue = !this.toggleValue
    },
    saveEvento (eventoId) {
      this.eventoId = eventoId
    },
    saveBoardAndColumn (boardAndColumn) {
      this.boardId = boardAndColumn[0]
      this.boardColumnId = boardAndColumn[1]
    },
    saveOrigin (origin) {
      this.origemId = origin
    },
    loadColumns (boardId) {
      this.boardId = boardId
    },
    handleSelectUpdate (fieldName, selectedValue) {
      // If input comes as a string or a number
      if (
        typeof selectedValue === 'string' ||
        typeof selectedValue === 'number'
      ) {
        this.data[fieldName] = selectedValue
        return
      }

      // If to clear multiple select
      if (Array.isArray(selectedValue) && !selectedValue.length) {
        this.clearField(fieldName)
        return
      }

      // If to clear single select and update both types
      this.data[fieldName] = selectedValue
        ? Array.isArray(selectedValue)
          ? selectedValue.map((v) => v.value)
          : selectedValue.value
        : this.clearField(fieldName)
    },
    handleInputUpdate (fieldName, inputedValue, clean = true) {
      this.data[fieldName] = inputedValue
        ? clean
          ? inputedValue.replace(/[^a-zA-Z0-9 ]/g, '')
          : inputedValue
        : this.clearField(fieldName)
    },
    handleArrayIndexUpdate (
      index,
      fieldName,
      selectedValue,
      inputType,
      clean = true
    ) {
      // If field is on array index
      if (index < 0) return

      if (inputType === 'select') {
        // If input comes as a string or a number
        if (
          typeof selectedValue === 'string' ||
          typeof selectedValue === 'number'
        ) {
          this.formData[index][fieldName] = selectedValue
          return
        }
        // If to clear multiple select
        if (Array.isArray(selectedValue) && !selectedValue.length) {
          this.formData[index][fieldName] = null
          return
        }
        // If to clear single select and update both types
        this.formData[index][fieldName] = selectedValue || null
      } else {
        this.formData[index][fieldName] = selectedValue
          ? clean
            ? selectedValue.replace(/[^a-zA-Z0-9 ]/g, '')
            : selectedValue
          : null
      }
    },
    openNewFollowUp (obj) {
      this.task = obj
      this.$nextTick(() => {
        this.openFollowUpModal = true
      })
    },
    closeNewFollowUp () {
      this.openFollowUpModal = false
    }
  }
}
</script>
<style lang="scss">
.formulate-input-element.formulate-input-element--textarea {
  max-width: 100% !important;
}

.newRule__inputs__container {
  display: flex;
  gap: 1rem;
  justify-content: space-between;

  .formulate-input {
    width: 100%;
  }
}
.toggle__text {
  font-weight: 400;
  font-size: 1.1rem;
  line-height: auto;
  cursor: pointer;
  letter-spacing: -0.04em;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/private/StartPage/modal/OportunityModal.vue